export var FactEnum;
(function (FactEnum) {
    FactEnum["numberOfRooms"] = "numberOfRooms";
    FactEnum["livingSpace"] = "livingSpace";
    FactEnum["numberOfFloors"] = "numberOfFloors";
    FactEnum["overallSpace"] = "overallSpace";
    FactEnum["plotSpace"] = "plotSpace";
    FactEnum["numberOfBeds"] = "numberOfBeds";
    FactEnum["numberOfBedrooms"] = "numberOfBedrooms";
    FactEnum["restaurantSpace"] = "restaurantSpace";
    FactEnum["officeSpace"] = "officeSpace";
    FactEnum["divisible"] = "divisible";
    FactEnum["storageSpace"] = "storageSpace";
    FactEnum["sellSpace"] = "sellSpace";
    FactEnum["availability"] = "availability";
    FactEnum["buildingPermission"] = "buildingPermission";
    FactEnum["deliveryDate"] = "deliveryDate";
})(FactEnum || (FactEnum = {}));
